import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule, Injectable } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ToastrModule } from 'ngx-toastr';
import { LSelect2Module } from 'ngx-select2';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

/* 사용자 */
import { HAuthService } from '@home/service/auth.service';
import { AuthLoginCheck } from '@home/service/auth.login.check';

import { GlobalErrorHandler } from '@app/service/global-error-handler';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core' ;
import { HttpLoaderFactory } from './home/home.module';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgbModule,
    LSelect2Module,
    SlickCarouselModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-bottom-right'
    }),
    TranslateModule.forRoot({
      defaultLanguage : 'ko',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    HAuthService,
    AuthLoginCheck,
    {provide: ErrorHandler, useClass: GlobalErrorHandler},
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
